export default __webpack_public_path__ + "static/media/logo-header.e6d2220c.png";